import React, { ReactElement, ReactNode } from 'react';
import PropTypes from 'prop-types';

import './AddressCard.scss';
import { LOCALE } from 'other/config';
import { PLACEHOLDER } from 'other/constants';
import { EProviderMediaObjectType, TProviderAddress } from 'types';

type Props = {
  item: TProviderAddress;
};

const AddressCard = ({ item }: Props): ReactElement | null => {
  if (!item) return null;

  const { address, city, country, postcode, title } = item;
  const countryString = country && country.value[LOCALE];
  const titleStub: ReactNode = (
    <img alt="" src={PLACEHOLDER.LOCATION_CARD} draggable={false} />
  );

  return (
    <div className="AddressCard">
      <ul className="AddressCard__list app-body-2">
        <li>
          <h6 className="AddressCard__title app-subtitle-1">
            {title || titleStub}
          </h6>
        </li>
        <li>{address}</li>
        <li>{city}</li>
        <li>{postcode}</li>
        <li>{countryString}</li>
      </ul>
    </div>
  );
};

AddressCard.label = EProviderMediaObjectType.LOCATION;
AddressCard.propTypes = {
  item: PropTypes.shape({
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    country: PropTypes.object,
    postcode: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })
};

export default AddressCard as any;
